import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { DashboardAssociationProvider } from '../../../context/DashboardAssociationContext'
import DashboardAssociationHome from './start/DashboardAssociationHome'
import DashboardBooklets from './booklets/DashboardBooklets'
import DashboardResources from './resources/DashboardResources'
import DashboardResellers from './resellers/DashboardResellers'
import DashboardFooter from '../DashboardFooter'

interface DashboardAssociationLayoutProps {
  match: {
    params: {
      association: string
    }
  }
}

const DashboardAssociationLayout: React.FC<DashboardAssociationLayoutProps> = ({ match }) => {
  const { association } = match.params

  return (
    <DashboardAssociationProvider associationId={association}>
      <Switch>
        <Route
          path="/cities/associations/:association/home"
          exact
          component={DashboardAssociationHome}
        />
        <Route
          path="/cities/associations/:association/booklets"
          exact
          component={DashboardBooklets}
        />
        <Route
          path="/cities/associations/:association/resources"
          exact
          component={DashboardResources}
        />
        <Route
          path="/cities/associations/:association/resellers"
          exact
          component={DashboardResellers}
        />
      </Switch>
      <DashboardFooter />
    </DashboardAssociationProvider>
  )
}

export default DashboardAssociationLayout
